// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"612":"b4b74ddf","978":"1599eaa8"}[chunkId] + ".chunk.css";
};